/**
 * Collection Description — Read More / Read Less toggle
 * - Hides the entire section if description has no visible text.
 * - Hides the toggle button when content fits without truncation.
 */
(function () {
  var sections = document.querySelectorAll('.collection-description');

  sections.forEach(function (section) {
    var textEl = section.querySelector('[data-collection-description-text]');
    var btn = section.querySelector('[data-collection-description-toggle]');
    if (!textEl || !btn) return;

    // Hide entire section if description is empty (catches empty <p></p> tags from richtext)
    var textContent = textEl.textContent || '';
    if (textContent.trim().length === 0) {
      section.style.display = 'none';
      return;
    }

    var labelEl = btn.querySelector('[data-toggle-label]');

    /**
     * Check whether the text is actually overflowing (truncated).
     * scrollHeight > clientHeight means line-clamp is cutting content.
     */
    function checkOverflow() {
      var isOverflowing = textEl.scrollHeight > textEl.clientHeight + 1;

      if (isOverflowing) {
        btn.style.display = '';
      } else {
        btn.style.display = 'none';
      }
    }

    // Initial check
    checkOverflow();

    // Re-check on resize (line-clamp changes between breakpoints)
    window.addEventListener('resize', checkOverflow);

    // Toggle behavior
    btn.addEventListener('click', function () {
      var isExpanded = textEl.classList.contains('collection-description__text--expanded');

      if (isExpanded) {
        textEl.classList.remove('collection-description__text--expanded');
        textEl.classList.add('collection-description__text--truncated');
        btn.classList.remove('collection-description__toggle--expanded');
        btn.setAttribute('aria-expanded', 'false');
        labelEl.textContent = 'Read More';

        // Re-check overflow after collapsing
        checkOverflow();
      } else {
        textEl.classList.remove('collection-description__text--truncated');
        textEl.classList.add('collection-description__text--expanded');
        btn.classList.add('collection-description__toggle--expanded');
        btn.setAttribute('aria-expanded', 'true');
        labelEl.textContent = 'Read Less';
      }
    });
  });
})();
